import { STATUS_COLORS, STATUS_LABELS } from './incidentLabels';
import type { IncidentStatus } from '../../types/extranet-api.types';

interface IncidentStatusBadgeProps {
  status: IncidentStatus;
  size?: 'sm' | 'md';
}

export const IncidentStatusBadge = ({ status, size = 'sm' }: IncidentStatusBadgeProps) => {
  const tokens = STATUS_COLORS[status];
  const padding = size === 'md' ? 'px-2.5 py-1' : 'px-2 py-0.5';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md text-xs font-medium ${padding} ${tokens.bg} ${tokens.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${tokens.dot}`} aria-hidden />
      {STATUS_LABELS[status]}
    </span>
  );
};
